import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Welcome from "./pages/Welcome";
import LoginPage from "./pages/Login"; // Your converted login page
import HomePage from "./pages/Home"; // Create a placeholder Home.tsx
// import ResetPasswordPage from "./pages/ResetPassword"; // Create a placeholder ResetPassword.tsx
// import SignupPage from "./pages/Signup"; // Create a placeholder Signup.tsx

const ResetPasswordPage: React.FC = () => <div>Reset Password Page</div>;
const SignupPage: React.FC = () => <div>Sign Up Page</div>;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/signup" element={<SignupPage />} />
        {/* Add routes for your new dashboard sections, e.g., /posts, /calendar, etc. */}
        <Route
          path="/posts"
          element={<h1 style={{ padding: "20px" }}>Posts Section</h1>}
        />
        <Route
          path="/calendar"
          element={<h1 style={{ padding: "20px" }}>Calendar Section</h1>}
        />
        <Route
          path="/requests"
          element={<h1 style={{ padding: "20px" }}>Requests Section</h1>}
        />
        <Route
          path="/ratings"
          element={<h1 style={{ padding: "20px" }}>Ratings Section</h1>}
        />
        <Route
          path="/events"
          element={<h1 style={{ padding: "20px" }}>Events Section</h1>}
        />
        <Route
          path="/favorites"
          element={<h1 style={{ padding: "20px" }}>Favorites Section</h1>}
        />
        <Route
          path="/companies"
          element={<h1 style={{ padding: "20px" }}>Companies Section</h1>}
        />
        <Route
          path="/labor"
          element={<h1 style={{ padding: "20px" }}>Labor Section</h1>}
        />
        <Route
          path="/products"
          element={<h1 style={{ padding: "20px" }}>Products Section</h1>}
        />
        <Route
          path="/services"
          element={<h1 style={{ padding: "20px" }}>Services Section</h1>}
        />
        <Route
          path="/notifications"
          element={<h1 style={{ padding: "20px" }}>Notifications Page</h1>}
        />
      </Routes>
    </Router>
  );
}

export default App;
